import BugReportSimpleQuestion from "./BugReportSimpleQuestion";
import * as theme from "../theme";

// Adapted from SimpleString

const BugReportSimpleString = ({ text, onInput, fieldId, value }) => {
  return (
    <BugReportSimpleQuestion
      leftString={text}
      rightComponent={
        <input
          type="text"
          id={"stringInput" + fieldId}
          style={{ ...theme.inputStyle }}
          onChange={onInput}
          value={value}
        ></input>
      }
    ></BugReportSimpleQuestion>
  );
};

export default BugReportSimpleString;
